export const PAGINATION_STATE_KEY = 'pagination';
